<template>
  <v-dialog v-model="show" persistent max-width="80%">
    <Card>
      <v-card-text style="max-height: 80vh; overflow-y: auto;">
        <v-row v-if="!isViewMode">
          <v-col cols="12" md="10">
            <span class="titulo-redencion">Solicitud</span>
            <span class="titulo-header">Crear Solicitud</span>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" md="10">
            <span class="titulo-redencion"
              >Redencion # {{ solicitudLocal.id }}</span
            >
            <span class="titulo-header"> {{ solicitudLocal.titulo }}</span>
          </v-col>
        </v-row>

        <div>
          <div ref="redencionSection">
            <RedencionForm
              :key="mode + (solicitudLocal.id || Math.random())"
              :mode="redMode"
              :solicitud="solicitudLocal"
              :showActions="showActions"
              :lockedTipo="lockedTipo"
              :lockedHasEmision="lockedHasEmision"
              @redencionNormal="saveRedencionStep($event, true)"
              @redencionSinEmision="saveRedencionStep($event, false)"
            />
          </div>

          <div ref="clienteSection">
            <ClienteForm
              :key="mode + (solicitudLocal.id || Math.random())"
              :mode="clientMode"
              :solicitud="solicitudLocal"
              @onSubmit="saveClient"
              @onCancel="stepBack"
              :clientSave="clientSave"
            />
          </div>

          <div v-if="isViewMode">
            <SeguimientoForm :solicitud="solicitudLocal" />
          </div>
        </div>
        <v-row class="mt-6" justify="end">
          <v-col cols="auto" class="text-right">
            <v-btn
              rounded
              dark
              color="#b11f1f"
              @click="cancelar"
              :disabled="loading"
            >
              Cerrar
            </v-btn>
            <v-btn
              rounded
              dark
              color="#b11f1f"
              class="ml-2"
              @click="saveRedencion"
              :loading="loading"
              :disabled="loading"
              v-if="!isInsertingClient && !isViewMode && !insertedRedencion"
            >
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </Card>
  </v-dialog>
</template>

<script>
import RedencionForm from "@/components/solicitudes/forms/RedencionForm.vue";
import ClienteForm from "@/components/solicitudes/forms/ClienteForm.vue";
import Card from "@/components/commondComponents/Card.vue";
import SeguimientoForm from "@/components/solicitudes/forms/SeguimientoForm.vue";
import { createSolicitudManual } from "@/services/solicitudService";
export default {
  components: { RedencionForm, ClienteForm, SeguimientoForm, Card },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "create",
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    solicitud: {
      type: Object,
      default: () => ({}),
    },
    lockedTipo: {
      type: String,
      default: null, //'Redención Beneficio' o 'Redención Asistencia'
    },
    lockedHasEmision: {
      type: String, //'Redención Normal' o 'Redención sin Emisión'
      default: null,
    },
    ignoreClientStep: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      solicitudLocal: {},
      rol: JSON.parse(localStorage.getItem("roles"))?.[0]?.rol || "",
      loading: false,
      redMode: "",
      clientMode: "view",
      clientSave: false,
    };
  },
  watch: {
    solicitud: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.solicitudLocal = JSON.parse(JSON.stringify(newVal || {}));
      },
    },
    mode: {
      immediate: true,
      handler(newMode) {
        this.redMode = newMode;
      },
    },
  },
  computed: {
    isViewMode() {
      return this.mode === "view";
    },
    isInsertingClient() {
      return this.clientMode === "create";
    },
    insertedRedencion() {
      return this.redMode === "create";
    },
  },
  methods: {
    saveRedencionStep(solicitudLocal, redencionNormal) {
      this.redMode = "view";
      if (this.ignoreClientStep === false) {
        this.clientSave = true;

        if (redencionNormal === true) {
          this.clientMode = "view";
        } else {
          this.clientMode = "create";
        }
      }

      this.solicitudLocal = solicitudLocal;
      const section = this.$refs.clienteSection;
      if (section) section.scrollIntoView({ behavior: "smooth" });
    },

    saveClient(cliente) {
      this.solicitudLocal = {
        ...this.solicitudLocal,
        ...cliente,
      };
      this.clientSave = false;
      this.clientMode = "view";
      this.saveRedencion();
    },
    async saveRedencion() {
      this.loading = true;
      const data = {
        ...this.solicitudLocal,
        fromExcepcion: false,
        origen: "Portal",
        redimirBeneficioAsistencia: true,
        status: 1,
        telefono: this.solicitudLocal.celular,
      };

      try {
        const res = await createSolicitudManual(data);
        if (res.status === 200) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.push(`/solicitud/${res.data.solicitud.id}`);
          }, 1500);
        } else {
          this.$toast.info(res.message);
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Ocurrió un error al crear la redención");
      } finally {
        this.loading = false;
      }
    },
    stepBack() {
      this.redMode = "create";
      this.solicitudLocal.cliente_id = null;
      this.$nextTick(() => {
        const section = this.$refs.redencionSection;
        if (section) section.scrollIntoView({ behavior: "smooth" });
      });
    },

    cancelar() {
      this.solicitudLocal = {};
      this.redMode = "create";
      this.clientMode = "view";
      this.clientSave = false;

      this.$emit("close");
      this.$emit("reset");
    },
  },
};
</script>

<style scoped>
.titulo-redencion {
  font-weight: 700;
  font-size: 32px;
  color: #130707;
  display: block;
  padding-bottom: 5px;
}
.titulo-header {
  font-weight: 600;
  font-size: 20px;
  display: block;
  margin-top: 4px;
}
</style>
